import React from 'react';
import PropTypes from 'prop-types';
import { Icon } from 'components/Icon/Icon';
import './PreviewCard.scss';

/**
 * PreviewCard - Reusable card component for displaying contract preview fields
 * 
 * @param {string} iconName - Name of the icon from Icon component
 * @param {string} label - Field label
 * @param {any} value - Field value to display
 * @param {string} placeholder - Placeholder text when value is empty
 * @param {number} confidence - Confidence score (0-1) for AI-extracted fields
 * @param {string} className - Additional CSS classes
 * @param {string} valueClassName - Additional CSS classes for the value element
 */
export const PreviewCard = ({
  iconName,
  label,
  value,
  placeholder,
  confidence,
  className = '',
  valueClassName = '',
}) => {
  const hasValue = value !== null && value !== undefined && value !== '';

  const getConfidenceLevel = (score) => {
    if (score >= 0.8) return 'high';
    if (score >= 0.5) return 'medium';
    return 'low';
  };

  return (
    <div className={`preview-card ${className}`}>
      <div className='preview-card-header'>
        <div className='preview-card-icon'>
          <Icon name={iconName} size='sm' />
        </div>
        <label>
          {label}
          {confidence !== undefined && confidence !== null && (
            <span
              className={`confidence-indicator confidence-${getConfidenceLevel(confidence)}`}
              title={`Confidence: ${(confidence * 100).toFixed(0)}%`}
            >
              ●
            </span>
          )}
        </label>
      </div>
      <div className='preview-card-content'>
        <span
          className={`${hasValue ? `preview-value ${valueClassName}` : 'placeholder-text'}`}
        >
          {hasValue ? value : placeholder}
        </span>
      </div>
    </div>
  );
};

PreviewCard.propTypes = {
  iconName: PropTypes.string.isRequired,
  label: PropTypes.string.isRequired,
  value: PropTypes.any,
  placeholder: PropTypes.string.isRequired,
  confidence: PropTypes.number,
  className: PropTypes.string,
  valueClassName: PropTypes.string,
};

export default PreviewCard;
